import { useQuery, useMutation } from "@tanstack/react-query";
import clientPortalAxiosInstance from "../../common/utilities/axios/clientPortalAxiosInstance";

/**Queries */
export const useGetProgrammeDescriptorByIdQuery = ({ programDescriptorId }) => {
  return useQuery({
    queryKey: ["getProgrammeDescriptorByIdQuery", `${programDescriptorId}`],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(
          `/Reports-Resources/report/getProgramDescriptorsById/${programDescriptorId}`
        )
        .then((res) => {
          return res.data;
        });
    },
    // The query will not execute until the programDescriptorId exists
    enabled: !!programDescriptorId,
  });
};

/**Mutations */
export const useViewProgrammeDescriptorListMutation = () => {
  return useMutation({
    mutationFn: ({ loggedInUserId, roleId, isEnterpriseAdmin }) => {
      return clientPortalAxiosInstance.post(
        `/Reports-Resources/report/roleBasedGetAllProgramDescriptors`,
        {
          LoggedInUserId: loggedInUserId || "",
          RoleId: roleId || "",
          IsEnterpriseAdmin: isEnterpriseAdmin,
        }
      );
    },
  });
};

/**same API for Create */
export const useCreateProgramDescriptorMutation = () => {
  return useMutation({
    mutationFn: ({ body }) => {
      return clientPortalAxiosInstance.post(
        `/Reports-Resources/report/createProgramDescriptor`,
        body
      );
    },
  });
};

/**same API for Update */
export const useUpdateProgramDescriptorMutation = () => {
  return useMutation({
    mutationFn: ({ body, programDescriptorId }) => {
      return clientPortalAxiosInstance.put(
        `/Reports-Resources/report/updateProgramDescriptor/${programDescriptorId}`,
        body
      );
    },
  });
};

// // api for delete client user
export const useDeleteProgramDescriptorMutation = () => {
  return useMutation({
    mutationFn: ({ isDeleteMode, programDescriptorId }) => {
      return clientPortalAxiosInstance.delete(
        `/Reports-Resources/report/deleteProgramDescriptor/${programDescriptorId}`,
        {
          data: {
            IsDeleteMode: isDeleteMode,
          },
        }
      );
    },
  });
};

export const useGetAllClientForPDMutation = () => {
  return useMutation({
    mutationFn: ({ reportResourceId }) => {
      return clientPortalAxiosInstance.get(
        `/Reports-Resources/report/getAllClientForPD/${reportResourceId}`
      );
    },
  });
};

export const useUploadProgramDescriptorFileMutation = () => {
  return useMutation({
    mutationFn: ({ file }) => {
      /**file is single file and not array of files */

      const formData = new FormData();
      formData.append("file", file);

      return clientPortalAxiosInstance.post(
        `/Reports-Resources/report/uploadProgramDescriptorDocument`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    },
  });
};
